import type { FC } from 'react';
import { useNavigate } from 'react-router-dom';

import { useCreateEvalConfigForm } from '../hooks/useCreateEvalConfigForm';
import { useCreateEvalConfigMutation } from '../hooks/useEvalConfigMutations';
import { CreateEvalConfigModal } from '../views/CreateEvalConfigModal';

interface CreateEvalConfigModalControllerProps {
  handleClose: () => void;
}

export const CreateEvalConfigModalController: FC<CreateEvalConfigModalControllerProps> = ({ handleClose }) => {
  const navigate = useNavigate();
  const { control, handleSubmit, isValid, formValues } = useCreateEvalConfigForm();

  const { onCreate, isLoading } = useCreateEvalConfigMutation({
    onSuccess: (id) => {
      handleClose();
      navigate(`/eval-configs/${id}`);
    },
  });

  return (
    <CreateEvalConfigModal
      control={control}
      isLoading={isLoading}
      isValid={isValid && formValues.name.trim().length > 0}
      isStarterChosen={formValues.copy_from !== 'BLANK'}
      onClose={handleClose}
      onSubmit={handleSubmit(onCreate)}
    />
  );
};
